import { Icon } from "@/components/ui/Icon";
import { duration } from "@/lib/format";
import { STATUS_LABELS } from "@/lib/labels";
import type { LeaderRow } from "@/lib/api/dashboard";
import "./dashboard.css";

/**
 * Rol bo'yicha eng natijali xodimlar.
 *
 * Umumiy podiumdan FARQI: podium eng ko'p ish bajargan uch
 * xodimni ko'rsatadi va u odatda bitta kasbdan iborat bo'lib
 * qoladi — terish topshiriqlari qolganlaridan ko'p va teruvchilar
 * doim tepada turadi. Bu yerda esa har bir kasb O'Z ichida
 * taqqoslanadi: eng yaxshi qabul qiluvchi ham, eng yaxshi
 * nazoratchi ham ko'rinadi.
 *
 * Tur bo'yicha guruhlanadi, rol bo'yicha emas: rol xodim
 * kartasida turadi va bir nechta bo'lishi mumkin (teruvchi +
 * katta xodim), KPI esa BAJARILGAN ish bo'yicha yig'iladi.
 */

const typeLabel = (value: string) => STATUS_LABELS[value] ?? value;

export function RoleLeaders({
  rows,
  names,
  loading,
}: {
  rows: LeaderRow[];
  names: Map<string, string>;
  loading?: boolean;
}) {
  if (loading) {
    return (
      <div className="leader-grid">
        {[0, 1, 2].map((index) => (
          <div className="skeleton" style={{ height: 104 }} key={index} />
        ))}
      </div>
    );
  }

  // Tur bo'yicha guruhlaymiz: server tartibni saqlaydi (tur,
  // keyin o'rin), shuning uchun qayta saralash kerak emas.
  const groups = new Map<string, LeaderRow[]>();
  for (const row of rows) {
    const list = groups.get(row.task_type) ?? [];
    list.push(row);
    groups.set(row.task_type, list);
  }

  if (groups.size === 0) {
    return (
      <p className="field-hint" style={{ margin: 0 }}>
        Bu davrda yakunlangan topshiriq yo'q — reyting bo'sh.
      </p>
    );
  }

  // Ko'p ish bajarilgan kasb tepada: dispetcher ko'zi birinchi
  // navbatda shu yerga tushadi.
  const ordered = [...groups.entries()].sort(
    (left, right) => (right[1][0]?.task_count ?? 0) - (left[1][0]?.task_count ?? 0),
  );

  return (
    <div className="leader-grid">
      {ordered.map(([taskType, list]) => {
        const leader = list[0]!;
        const runnerUp = list[1];
        const name = names.get(leader.employee_id) ?? "Xodim";

        return (
          <article className="leader-card" data-type={taskType} key={taskType}>
            <div className="leader-type">{typeLabel(taskType)}</div>

            <div className="leader-name" title={name}>
              {name}
            </div>
            <div className="leader-stats">
              <b className="num">{leader.task_count}</b> topshiriq ·{" "}
              {leader.line_count} SKU · {duration(leader.work_seconds)}
            </div>

            {/* Kamomad YASHIRILMAYDI: faqat tezlikni ko'rsatish
                shoshilishni rag'batlantirardi, sifatni esa yo'q. */}
            {leader.shortage_count > 0 && (
              <div className="leader-warn">
                <Icon name="alert" size={12} />
                {leader.shortage_count} kamomad
              </div>
            )}

            {/* Ikkinchi o'rin — liderni QUVIB kelayotgan xodim.
                Usiz reyting bitta ismga aylanib, qolganlarga hech
                narsa aytmasdi. */}
            {runnerUp && (
              <div className="leader-next">
                2. {names.get(runnerUp.employee_id) ?? "Xodim"} —{" "}
                <span className="num">{runnerUp.task_count}</span>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}
